import { render, staticRenderFns } from "./AddPantalla.vue?vue&type=template&id=55f3613a&"
import script from "./AddPantalla.vue?vue&type=script&lang=ts&"
export * from "./AddPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports